import 'intersection-observer'

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './js/router/router'
import store from './store'
import Is from 'is_js'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebookF, faTwitter, faGithub, faWeixin, faTelegramPlane, faDiscourse } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faPuzzlePiece, faInfinity, faShareAlt, faDigitalTachograph, faSun, faBoxes, faRocket } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faFacebookF, faTwitter, faGithub, faWeixin, faDiscourse, faEnvelope,
  faPuzzlePiece, faInfinity, faShareAlt, faDigitalTachograph,
  faSun, faBoxes, faRocket, faTelegramPlane
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.prototype.GLOBAL = {
  windowScrolling: false,
  wheeling: false,
  currentWindow: 0,
}

import LocalStore from './js/localstore/localStorage'
import LangEN from './js/i18n/en'
import LangZH from './js/i18n/zh'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

Vue.use(VueMaterial)

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: LocalStore.GetLang('en'),
  messages: {
    'en': LangEN,
    'zh': LangEN,
  }
})

window.$I18n = i18n

import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility)

window.$VueInstance = new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
